export default {
    workingHour: null,
    businessInfo: {},
    listBusinessBlockTime: { items: [], _links: {}, _meta: {} },
    listStaffBlockTime: { items: [], _links: {}, _meta: {} },
    blockTime : {}
}
